import { addItemToCollection } from "directus/src/operations";

export async function createSkill({ item }) {
  try {
    const data = await addItemToCollection("skills", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
